import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca5ff64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"color":"black","font-size":"xx-large"} }, "Submissions", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { m: "4" }
const _hoisted_11 = {
  key: 0,
  m: "t-0 b-2"
}
const _hoisted_12 = {
  key: 1,
  m: "t-0 b-2"
}
const _hoisted_13 = {
  key: 2,
  m: "t-0 b-2"
}
const _hoisted_14 = {
  key: 3,
  m: "t-0 b-2"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Are you sure to reject this submission? It means that this algorithm will not be added to the leaderboard, and such a decision is irreversible. ", -1))
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Are you sure to approve this submission? It means that this algorithm will be added to the leaderboard. ", -1))
const _hoisted_22 = { class: "dialog-footer" }

import {handleError, onMounted, ref} from "vue";
import request from '@/api/index'
import store from '@/store'
import {router} from "@/router";
import {ElMessage} from "element-plus";
// import { DetermineUser } from '@/pages/Cifar/cifar'; // 导入你的组件路径



export default /*#__PURE__*/_defineComponent({
  __name: 'cub',
  setup(__props) {

const tableData=ref()
const search=ref("")
const visible = ref(false)
const centerDialogVisible = ref(false)
const centerDialogVisibleApprove = ref(false)
const chosenId = ref(0)
const chosenApproveId = ref(0)
const algorithmName = ref('')
const morfPath = ref('')
const lerfPath = ref('')


// centerDialogVisible = false



function chooseRejectId(algorithmId){
  console.log("好好好")
  console.log("algorithmId: ", algorithmId)
  centerDialogVisible.value = true
  chosenId.value = algorithmId
}

function chooseApproveId(algorithmId, name, morf, lerf){
  console.log("坏坏坏")
  console.log("algorithmId: ", algorithmId)
  console.log("algorithmName: ", name)
  console.log("morf: ", morf)
  console.log("lerf: ", lerf)
  centerDialogVisibleApprove.value = true
  algorithmName.value = name
  chosenApproveId.value = algorithmId
  morfPath.value = morf
  lerfPath.value = lerf
}


function getTableData(){
  request.post('/history/findAll',{
    username: store.state.username,
  })
      .then((response)=>{
        console.log(response)
        let originData=response.data.data.infoInfos
        console.log("originData: ", originData)

        tableData.value=originData.filter(
            (data) => {
              // console.log(data.datasetName.toLowerCase(), search.value)
              return (!search.value.length) || data.datasetName.toLowerCase().includes(search.value.toString().toLowerCase())
            }
        )
        store.commit('setHistoryRecords', tableData.value)
        console.log("tableData", tableData.value)
      })
      .catch((error)=>{
        console.error(error)
      })
}

async function handleReject(algorithmId){
  console.log("algorithmId:", algorithmId)
  await request.post('/algorithm/handleReject',{
    algorithmId: algorithmId,
  })
      .then((response)=>{
        console.log(response)
        if(response.status==200){
          ElMessage.success("You have rejected this submission!")
        }else{
          ElMessage.error("Rejection failed.")
        }
      })
      .catch((error)=>{
        ElMessage.error("Rejection failed.")
        console.error(error)
      })
  getTableData()
  centerDialogVisible.value = false
}

function DetermineUser() {
  console.log("确认用户信息")
  let temp = {
    username: store.state.username,
    password: 23333,
  };
  console.log(temp);
  request
      .post("/user/findNoPass", temp)
      .then((res) => {
        console.log(res)
        if (res.status === 200) {
          console.log("确认成功")
          const userInfo = res.data.data.userInfo
          store.commit('setInstitute', userInfo.institute)
          console.log("userInfo.institute: ", userInfo.institute)
          console.log("store.state.institute: ", store.state.institute)
        } else{
          console.log("确认失败")
        }
      })
      .catch((err) => {
        console.log((err));
      });

}

async function handleApprove(algorithmId){
  DetermineUser();
  console.log("algorithmId:", algorithmId)
  await request.post('/algorithm/handleApprove',{
    algorithmId: algorithmId,
    username: store.state.username,
    institute: store.state.institute,
    name: algorithmName.value,
    morf: morfPath.value,
    lerf: lerfPath.value
  })
      .then((response)=>{
        console.log(response)
        if(response.status==200){
          ElMessage.success("You have approved this submission!")
        }else{
          ElMessage.error("Approval failed.")
        }
      })
      .catch((error)=>{
        ElMessage.error("Approval failed.")
        console.error(error)
      })
  getTableData()
  centerDialogVisibleApprove.value = false
}

getTableData()
// console.log("tableData", tableData.value)

function handleDelete(index:any,recordData:any){
  request.post('/history/delete',{
    historyName: recordData.historyName,
    username: store.state.username
  })
      .then((response)=>{
        console.log("handleDelete", response)
        tableData.value.splice(index, 1)
      })
      .catch((error)=>{
        console.log("handleDelete", error)
      })
}

function getRecordDetail(index:any, recordData:any) {

  router.push({
    name: 'twodresult',
    params: {
      recordDatasetId: tableData.value[index].datasetId,
      recordName: recordData.historyName
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: tableData.value,
      "default-sort": { prop: ['dateTime'], order: 'descending' },
      style: {"width":"100%"},
      border: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          "min-width": "120",
          fixed: "",
          prop: "username",
          label: "user name"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "120",
          prop: "institute",
          label: "institute"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          prop: "morfPath",
          label: "submission type"
        }, {
          default: _withCtx((props) => [
            (props.row.morfPath==='leaderboard')
              ? (_openBlock(), _createElementBlock("text", _hoisted_3, "algorithm (leaderboard)"))
              : (props.row.morfPath==='suggestion')
                ? (_openBlock(), _createElementBlock("text", _hoisted_4, "suggestion/bug/issue"))
                : (_openBlock(), _createElementBlock("text", _hoisted_5, _toDisplayString(props.row.morfPath), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "120",
          prop: "name",
          label: "algorithm name"
        }, {
          default: _withCtx((props) => [
            (props.row.morfPath==='leaderboard')
              ? (_openBlock(), _createElementBlock("text", _hoisted_6, _toDisplayString(props.row.name), 1))
              : (_openBlock(), _createElementBlock("text", _hoisted_7, "N/A"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "120",
          prop: "lerfPath",
          label: "algorithm type"
        }, {
          default: _withCtx((props) => [
            (props.row.morfPath==='leaderboard')
              ? (_openBlock(), _createElementBlock("text", _hoisted_8, _toDisplayString(props.row.lerfPath), 1))
              : (_openBlock(), _createElementBlock("text", _hoisted_9, "N/A"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "130",
          prop: "dateTime",
          label: "Submit Time",
          sortable: "sortable"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "40",
          label: "Infos",
          type: "expand"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", _hoisted_10, [
              (props.row.morfPath==='leaderboard')
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Algorithm information: " + _toDisplayString(props.row.info), 1))
                : (props.row.morfPath==='suggestion')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, "User suggestion: " + _toDisplayString(props.row.info), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, "User script: " + _toDisplayString(props.row.info), 1)),
              (props.row.morfPath==='leaderboard')
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Algorithm statistics / Paper link: " + _toDisplayString(props.row.email), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Decisions",
          "min-width": "160"
        }, {
          default: _withCtx((props) => [
            (props.row.status==='In Process'&&(props.row.morfPath==='leaderboard'||props.row.morfPath==='pruning task'||props.row.morfPath==='upload task'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: ($event: any) => (chooseApproveId(props.row.algorithmId, props.row.name, props.row.morfPath, props.row.lerfPath)),
                    type: "success",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Approve ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "danger",
                    onClick: ($event: any) => (chooseRejectId(props.row.algorithmId)),
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Reject")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : (props.row.morfPath==='suggestion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_el_text, {
                      class: "mx-1",
                      type: "info",
                      style: {"color":"#4C4C4C","font-weight":"bold"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("N/A")
                      ]),
                      _: 1
                    })
                  ]))
                : (props.row.status==='Rejected')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "danger",
                        style: {"color":"#AB140C","font-weight":"bold"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.status), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (props.row.status==='Approved')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_el_text, {
                          class: "mx-1",
                          type: "success",
                          style: {"color":"#67C23A","font-weight":"bold"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.status), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: centerDialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((centerDialogVisible).value = $event)),
      title: "Warning",
      width: "30%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (centerDialogVisible.value = false)),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleReject(chosenId.value))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirm ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_19
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: centerDialogVisibleApprove.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((centerDialogVisibleApprove).value = $event)),
      title: "Warning",
      width: "30%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (centerDialogVisibleApprove.value = false)),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleApprove(chosenApproveId.value))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirm ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_21
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})